import { FC, useCallback } from 'react';
import { useAppContext } from '@/context/AppContext';
import Button from '@/shared/components/Button/Button';
import './StartStopButton.css';

const StartStopButton: FC = () => {
  const { clock, startClock, stopClock } = useAppContext();

  const handleClick = useCallback(() => {
    if (!clock) return;
    if (clock.running) {
      stopClock();
    } else {
      startClock();
    }
  }, [clock, startClock, stopClock]);

  if (!clock) return null;

  return (
    <Button
      onClick={handleClick}
      variant="primary"
      className={clock.running ? 'running' : ''}
      icon={clock.running ? 'Square' : 'Play'}
    />
  );
};

export default StartStopButton;
